// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"276688c9","453":"4ad17a97"}[chunkId] + ".chunk.js";
};